import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { useTranslation } from '../../../src/i18n';
import { TP } from '../../../constants/consts';
import FormikAutocompleteSelect from '../../Fields/FormikAutocompleteSelect';

const useStyles = makeStyles(theme => ({
  field: {
    marginBottom: theme.spacing(2),
    width: '48%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  professionsBlock: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  orBlock: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}));

const ArtistProfessionFields = ({
  voiceTypes,
  professions,
  setValues,
  values,
  professionField,
  voiceField,
  className,
  fieldClass,
  formikFieldProps,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={cn(classes.professionsBlock, className)}>
      <div className={cn(classes.field, fieldClass)}>
        <Field
          instanceId={voiceField?.name}
          label={t(voiceField?.label)}
          name={voiceField?.name}
          component={FormikAutocompleteSelect}
          options={voiceTypes}
          preventDefaultOnChange
          withFiltering
          onChange={v => {
            setValues({
              ...values,
              [voiceField?.name]: v,
              [professionField?.name]: null,
            });
          }}
          {...formikFieldProps}
        />
      </div>
      <div className={classes.orBlock}>{t(`${TP}.FN_OR`)}</div>
      <div className={cn(classes.field, fieldClass)}>
        <Field
          instanceId={professionField?.name}
          label={t(`${TP}.m_EDIT_ROSTER_LIST_PROFESSION`)}
          name={professionField?.name}
          component={FormikAutocompleteSelect}
          options={professions}
          preventDefaultOnChange
          withFiltering
          onChange={v => {
            setValues({
              ...values,
              [voiceField?.name]: null,
              [professionField?.name]: v,
            });
          }}
          {...formikFieldProps}
        />
      </div>
    </div>
  );
};

ArtistProfessionFields.propTypes = {
  voiceTypes: PropTypes.array,
  professions: PropTypes.array,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  voiceField: PropTypes.object,
  professionField: PropTypes.object,
  className: PropTypes.string,
  fieldClass: PropTypes.string,
  formikFieldProps: PropTypes.object,
};

ArtistProfessionFields.defaultProps = {
  voiceTypes: [],
  professions: [],
  voiceField: { name: 'voice', label: `${TP}.m_EDIT_ROSTER_LIST_VOICE` },
  professionField: { name: 'profession', label: `${TP}.m_EDIT_ROSTER_LIST_PROFESSION` },
  className: '',
  fieldClass: '',
  formikFieldProps: {},
};

export default ArtistProfessionFields;
